/**
 * Copyright 2022 Design Barn Inc.
 */

import styled from 'styled-components';

export const Label = styled.label`
  font-size: 13px;
  div {
    color: rgb(106, 106, 106);
    font-size: 11px;
  }
`;
